import React from "react";
import { Link } from "react-router-dom";
import AnimatedBackground from "@/components/AnimatedBackground";
import { useAuth } from "@/context/AuthContext";
import { Search, Shield, Zap, Bitcoin } from "lucide-react";

export default function Landing() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen relative">
      <AnimatedBackground />

      <header className="px-6 md:px-12 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src="/assets/gulyan-favicon.png" alt="Gulyan" className="w-14 h-14 md:w-16 md:h-16 object-contain drop-shadow-[0_0_18px_rgba(157,78,221,0.35)]" />
          <div>
            <div className="font-heading text-2xl md:text-3xl font-black tracking-tight leading-none">GULYAN</div>
            <div className="text-[10px] md:text-[11px] tracking-[0.3em] text-[#9D4EDD] font-mono mt-1.5">CHECKER</div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {user ? (
            <Link to="/panel" className="gc-btn-primary" data-testid="landing-panel-btn">
              PANELE GİT
            </Link>
          ) : (
            <>
              <Link to="/login" className="gc-btn-ghost" data-testid="landing-login-btn">
                GİRİŞ
              </Link>
              <Link to="/register" className="gc-btn-primary" data-testid="landing-register-btn">
                KAYIT OL
              </Link>
            </>
          )}
        </div>
      </header>

      <section className="px-6 md:px-12 pt-16 md:pt-24 max-w-6xl mx-auto">
        <div className="gc-badge gc-badge-red mb-6">SİSTEM AKTİF</div>
        <h1 className="font-heading text-5xl md:text-7xl font-black tracking-tighter leading-[0.95]">
          DISCORD ID <br />
          <span className="text-[#9D4EDD]">DERİN TARAMA</span>
        </h1>
        <p className="mt-6 text-[#A1A1AA] text-base md:text-lg max-w-2xl">
          Sızdırılmış veri kayıtlarını Discord ID üzerinden anında sorgulayın. E-posta,
          IP, bağlantılar, sunucu üyelikleri — tek bir terminalden.
        </p>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to={user ? "/checker" : "/register"} className="gc-btn-primary" data-testid="landing-cta-checker">
            SORGULAMAYA BAŞLA
          </Link>
          <Link to="/magaza" className="gc-btn-ghost" data-testid="landing-cta-shop">
            ÜYELİKLER
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { icon: Search, title: "Anlık Sorgu", desc: "Milyonlarca kayıt arasında saniyeler içinde eşleşme." },
            { icon: Zap, title: "Gerçek Zamanlı Panel", desc: "Sorgu, üyelik ve limit istatistikleri canlı olarak." },
            { icon: Bitcoin, title: "Sadece BTC", desc: "Üyelikler yalnızca Bitcoin ile satın alınır." },
          ].map((f, i) => (
            <div key={i} className="gc-card-glow p-6">
              <f.icon size={22} className="text-[#9D4EDD]" />
              <h3 className="font-heading text-xl font-bold mt-4">{f.title}</h3>
              <p className="text-sm text-[#A1A1AA] mt-2">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-24 pb-16 flex items-center gap-3 text-xs text-[#A1A1AA] font-mono">
          <Shield size={12} />
          <span>SESSION_ENCRYPTED • JWT_HS256 • BCRYPT_HASH</span>
        </div>
      </section>
    </div>
  );
}
